/**
 * Orca runner install docs — eagerly registers the route and its `head()`,
 * deferring the page (the v5 frame around the three-step reading column) to
 * `runner-install.lazy.tsx`.
 *
 * The eager file imports only `~/lib/*` (bundle budgets): the orcaloops frame's
 * stylesheet is linked from {@link runnerInstallHead} via the pure
 * `~/lib/orcaloops-head.ts` (web CLAUDE.md rule 6), so the SSR markup paints
 * styled.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * Head meta tags and the frame stylesheet for the runner install docs page.
 *
 * @since 1.0.0
 */
export const runnerInstallHead = () => ({
  links: orcaloopsStylesheetLinks,
  meta: [
    { title: "Install a runner — Orcaloops" },
    {
      content: "Stand up a new orca build-runner host with one curl command: provision a token, run the installer, "
        + "verify the runner comes ONLINE.",
      name: "description",
    },
  ],
});

export const Route = createFileRoute("/orca/runner-install")({
  head: runnerInstallHead,
});
